/**
 * Patches Navigator LockManager for Supabase auth before any client initializes.
 * Auth locks must never wait — a held lock is what leaves the login button on
 * "Signing in..." forever.
 */
(function patchSupabaseAuthLocks() {
  if (typeof window === 'undefined') return;
  if (window.__grafitoAuthLockPatched) return;

  const locks = window.navigator?.locks;
  if (!locks?.request) return;

  const originalRequest = locks.request.bind(locks);

  locks.request = (name, options, callback) => {
    const lockName = typeof name === 'string' ? name : '';
    const isAuthLock = lockName.includes('auth-token');
    const fn = typeof options === 'function' ? options : callback;

    if (isAuthLock && typeof fn === 'function') {
      return Promise.resolve(fn({ name: lockName, mode: 'exclusive' }));
    }

    return originalRequest(name, options, callback);
  };

  window.__grafitoAuthLockPatched = true;
})();
